export const defaultChartColors = ["#4F8EF7", "#F76D57", "#FFD166", "#06D6A0", "#8338EC", "#FF61A6"];
